import React from 'react';
import { Box, Skeleton, Slider } from '@mui/material';
import './createSurvey.css';
export default function SingleSlider({
  value,
  values,
  setValues,
  loading,
  loadings,
  setFinalData,
  id,
}) {
  const handleChange = (e) => {
    console.log(e.target.value);
    const newState = values.map((obj) => {
      // 👇️ if id equals 2, update country property
      if (obj.id === value.id) {
        return { ...obj, value: e.target.value, altered: true };
      }

      // 👇️ otherwise return the object as is
      return obj;
    });

    setValues(newState);
    setFinalData((prev) => ({
      ...prev,
      T1: '',
      T2: '',
      T3: '',
      E1: '',
      E2: '',
      E3: '',
      S1: '',
      S2: '',
      C1: '',
      C2: '',
      L1: '',
      L2: '',
    }));
  };

  return (
    <div className="slider-conti">
      <div
        className="sliderNumber"
        style={{
          fontSize: '15px',
          backgroundColor: value.altered ? '#92D2C4' : 'white',
          color: value.altered ? 'white' : 'black',
        }}
      >
        {value?.id}
      </div>
      <div className="sliderMain">
        {loading || loadings ? (
          <Box sx={{ width: '100%' }}>
            <Skeleton />
          </Box>
        ) : (
          <div className="slider-title">{value?.title}</div>
        )}
        <div className="slider-image">
          <Box>
            <Slider
              value={value?.value}
              aria-label="Default"
              onChange={handleChange}
              color="primary"
              sx={{
                '& .css-14pt78w-MuiSlider-rail': {
                  color: '#fff',
                  opacity: 1,
                  borderRadius: '0px',
                },
                borderRadius: '0px',
                '& .Mui-active': {
                  opacity: 0.4,
                },
                '& .css-7drnjp:hover': { boxShadow: 'unset' },
                '& .css-7drnjp:active': { boxShadow: 'unset' },
                '& .css-7drnjp::before': {
                  backgroundColor: '#92D2C4',
                  backgroundSize: 'contain',
                  width: '5px',
                  // content: `"${value?.value}"`,
                  // height: '60px',
                  borderRadius: '0px',
                  color: 'red',
                  objectFit: 'cover',
                  backgroundPosition: 'center',
                  top: '9px',
                },
                '& .css-1hrolpu .Mui-active': {
                  opacity: 0,
                },
                '& .css-7drnjp::after': {
                  backgroundColor: '#92D2C4',
                  backgroundSize: 'contain',
                  content: `"${value?.value}"`,
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  objectFit: 'cover',
                  backgroundPosition: 'center',
                  // top: '50px',
                },
                '& .css-z1mf93-MuiSlider-root': {
                  borderRadius: '0px',
                },
                '& .css-7drnjp': {
                  width: '0px',
                  height: '0px',
                },
              }}
              style={{
                color: '#93d3c6',
                height: '20px',
              }}
            />
          </Box>
        </div>
      </div>
    </div>
  );
}
